import { services } from '@config/services';
import { catalogApi } from './base';
import type {
  DeleteMerchantVariantsPayload,
  MerchantVariantsMutationPayload,
  VariantMutationResult,
} from './types';

/**
 * Merchant-variant write endpoints. Add / update / delete variants in a
 * catalog. Each invalidates the catalog's variant LIST so the products table
 * refetches. These are the only path for variant writes — catalog metadata is
 * edited through `patchCatalog`.
 */
const merchantVariantsApi = catalogApi.injectEndpoints({
  endpoints: (builder) => ({
    /** POST /catalog/v1/merchantVariants */
    postMerchantVariants: builder.mutation<VariantMutationResult, MerchantVariantsMutationPayload>({
      query: (body) => ({
        url: `${services.catalog}/v1/merchantVariants`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (_r, _e, { merchantCatalogId }) => [
        { type: 'CatalogVariant', id: `LIST:${merchantCatalogId}` },
      ],
    }),

    /** PUT /catalog/v1/merchantVariants */
    putMerchantVariants: builder.mutation<VariantMutationResult, MerchantVariantsMutationPayload>({
      query: (body) => ({
        url: `${services.catalog}/v1/merchantVariants`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (_r, _e, { merchantCatalogId }) => [
        { type: 'CatalogVariant', id: `LIST:${merchantCatalogId}` },
      ],
    }),

    /** DELETE /catalog/v1/merchantVariants (ids in the request body). */
    deleteMerchantVariants: builder.mutation<VariantMutationResult, DeleteMerchantVariantsPayload>({
      query: (body) => ({
        url: `${services.catalog}/v1/merchantVariants`,
        method: 'DELETE',
        body,
      }),
      invalidatesTags: (_r, _e, { merchantCatalogId }) => [
        { type: 'CatalogVariant', id: `LIST:${merchantCatalogId}` },
      ],
    }),
  }),
});

export const {
  usePostMerchantVariantsMutation,
  usePutMerchantVariantsMutation,
  useDeleteMerchantVariantsMutation,
} = merchantVariantsApi;
